import React from 'react';
import styled from 'styled-components';
import VideoInput from '../VideoInput';
import { useTwilioUserMediaContext } from '../../customer-call-sdk';
import { localTrackToMediaStream } from '../../utils/local-track.util';

const StyledVideoView = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    .video-container {
        box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.14);
        border-radius: 0.625rem;
    }
    .video-container video {
        /* border-radius: 0.625rem; */
        transform: rotateY(180deg);
    }
`;

const VideoView: React.FunctionComponent = () => {
    const { videoTracks } = useTwilioUserMediaContext();

    const videoTrack = videoTracks[0];

    return (
        <StyledVideoView>
            {videoTrack && (
                <VideoInput
                    data-testid="video-view"
                    mediaStream={localTrackToMediaStream(videoTrack)}
                    className="video-container"
                    resize
                />
            )}
        </StyledVideoView>
    );
};

export default VideoView;
